import { ReactNode } from 'react';
import './styles/ConfirmModal.scss';

type Props = {
    open: boolean;
    title?: string;
    message: ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onClose: () => void;
};

export default function ConfirmModal({ open, title, message, confirmLabel = "Potvrdit", cancelLabel = "Zpět", onConfirm, onClose }: Props) {
    if (!open) return null;

    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalBox" onClick={(e) => e.stopPropagation()}>
                {title && <h3>{title}</h3>}
                <p>{message}</p>
                <div className="modalActions">
                    <div className="mBtn ghost" onClick={onClose}>{cancelLabel}</div>
                    <div className="mBtn confirm" onClick={onConfirm}>{confirmLabel}</div>
                </div>
            </div>
        </div>
    );
}
